export default __webpack_public_path__ + "static/media/evenShotMascot.574a1e15.png";